import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

/**
 * Shared state for the admin sidebar (collapse + mobile drawer).
 *
 * Persistence: `bmp_sidebar_state` localStorage key stores "expanded" | "collapsed".
 * Mobile drawer is in-memory only.
 */

const STORAGE_KEY = 'bmp_sidebar_state';

const SidebarContext = createContext({
  isCollapsed: false,
  toggleCollapsed: () => {},
  isMobileOpen: false,
  openMobile: () => {},
  closeMobile: () => {},
});


export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'collapsed';
    } catch { return false; }
  });

  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, isCollapsed ? 'collapsed' : 'expanded');
    } catch { /* no-op */ }
  }, [isCollapsed]);

  const toggleCollapsed = useCallback(() => setIsCollapsed((v) => !v), []);
  const openMobile = useCallback(() => setIsMobileOpen(true), []);
  const closeMobile = useCallback(() => setIsMobileOpen(false), []);

  return (
    <SidebarContext.Provider value={{
      isCollapsed, toggleCollapsed,
      isMobileOpen, openMobile, closeMobile,
    }}>
      {children}
    </SidebarContext.Provider>
  );
};


export const useSidebar = () => useContext(SidebarContext);

export default SidebarContext;
